// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"125":"7c8ff18b","222":"5211672d","234":"ec49612b","250":"89f59007","277":"26dd78e7","287":"b7f38a7e","459":"c58b847d","471":"80a1cfd3","474":"5987fd31","487":"88596fec","969":"ad3a0778"}[chunkId] + ".js";
};